import { render, staticRenderFns } from "./PhotoList.vue?vue&type=template&id=64d0a584&scoped=true&"
import script from "./PhotoList.vue?vue&type=script&lang=js&"
export * from "./PhotoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0a584",
  null
  
)

export default component.exports